// External deps
import { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useFormikContext } from 'formik';

// Internal deps

import { ubicationTypeEnum } from '../../../../../utils/dataStatus';
import AddUbicationForm from '../../../../AddUbicationForm/AddUbicationForm';
import { getUbicationLabel } from '../../../../../utils/getUbicationLabel';
import useUbicationForm from '../../../../CreateServiceRequest/UbicationForm/useUbicationForm';

const LocationForm = ({ params, setMaxWells, isTemplate, createSDS }) => {
  const { filteredBusinessUnits, optionsUbicationType, filteredOperations, disabledChangeUunn } =
    params;
  const { values, setFieldValue, errors, setFieldTouched, touched } = useFormikContext();

  const {
    event: eventOp,
    aditionalTeams,
    equipment,
    getEventIdPozo,
    getEventsIdTeam,
    handleSwitchAdditionTeams,
    fetchDataUbication,
    setUbicationState,
    setUunnState,
    setEventState,
    setTeamState,
    getUnitsBusinessId,
    getUnitsBusinessOfUser,
    cantWells,
    getOperationByInstallationId,
    fetchDataInstallation,
    optionUnits,
    setOptionUnits,
    fetchDataClassification,
    getOperationByClassificationId,
    getClassificationByUbicationId,
    getTypeOfEventsOptions,
    typeOfEventOptions
  } = useUbicationForm(
    false,
    true,
    null,
    null,
    null,
    createSDS,
    values?.ubication?.ubicationType?.id === ubicationTypeEnum.locacion
  );

  const ubicationLabel = getUbicationLabel(values?.ubication?.ubicationType?.id);
  // We need to select this fields before search a ubication or instalation
  const disableUbicationSearch =
    !values.ubication?.ubicationType ||
    ((!optionUnits?.length || !values.ubication?.uunn?.id) && isTemplate);

  const { isOyM } = values;

  const objectUbicationType = {
    label: 'Tipo de ubicación',
    placeholder: 'Buscar por tipo de ubicación',
    options: optionsUbicationType,
    name: 'ubication.ubicationType',
    onChange: (val) => {
      setFieldValue(
        'isOyM',
        val?.id !== ubicationTypeEnum.locacion && val?.id !== ubicationTypeEnum.pozo
      );
      if (val?.id !== values?.ubicationType?.id && val) {
        setFieldValue('ubication.ubicationType', val);
        // Limpio campos dependientes
        setFieldValue('ubication.ubication', null);
        setFieldValue('ubication.event', null);
        setFieldValue('ubication.team', null);
        setFieldValue('ubication.uunn', null);
        setFieldValue('ubication.classification', null);
      }
    },
    value: values?.ubication.ubicationType
  };

  const objectUunn = {
    options: optionUnits,
    onChange: (val) => {
      if (val && val?.id !== values.uunn?.id) {
        setFieldValue('ubication.uunn', val);
        setFieldTouched('ubication.uunn');
        setFieldValue('ubication.event', null);
        setFieldValue('ubication.team', null);
        setFieldValue('ubication.ubication', null);
        setFieldValue('ubication.classification', null);
        setUunnState(val);
      }
    },
    label: 'Unidad de Negocio',
    placeholder: 'Buscar por unidad de negocio',
    isDisabled: !values.ubication.ubicationType,
    errors: errors.ubication?.uunn,
    value: values.ubication.uunn,
    name: 'ubication.uunn'
  };

  const objectUbication = {
    placeholder: 'Buscar por nombre',
    name: 'ubication.ubication',
    onChange: async (val) => {
      if (val?.id !== values.ubication?.ubication?.id) {
        setFieldValue('ubication.ubication', val);
        setFieldValue('ubication.event', null);
        setFieldValue('ubication.team', null);
        setUbicationState(val);
        if (
          values.ubication?.ubicationType?.id === ubicationTypeEnum.genericaOverhead ||
          values.ubication?.ubicationType?.id === ubicationTypeEnum.genericaProyecto
        ) {
          getClassificationByUbicationId(val?.id);
        }

        if (val) {
          getUnitsBusinessId(val?.id);
        } else if (!disabledChangeUunn) {
          setFieldValue('ubication.uunn', null);
          getUnitsBusinessOfUser();
        }
        // Si es pozo se buscan los eventos
        if (val && values.ubication?.ubicationType?.id === ubicationTypeEnum.pozo) {
          getEventIdPozo(val);
        }
        if (val && values.ubication?.ubicationType?.id === ubicationTypeEnum.locacion) {
          getTypeOfEventsOptions(val?.id);
        }
      }
      if (!val) {
        setFieldValue('ubication.ubication', null);
        setFieldValue('ubication.event', null);
        setFieldValue('ubication.team', null);
        setFieldValue('ubication.typeEvent', null);
      }
    },
    value: values.ubication.ubication,
    isDisabled: disableUbicationSearch,
    label: ubicationLabel,
    fetchData: (value) =>
      fetchDataUbication(value, values.ubication.uunn ? values.ubication.uunn.id : 0)
  };

  const objectEvent = {
    label: 'Evento',
    placeholder: 'Selecciona un evento',
    options: eventOp,
    name: 'ubication.event',
    isDisabled: !values.ubication.ubicationType || !values.ubication.ubication,
    onChange: async (val) => {
      if (val?.eventoPozoId !== values?.ubication?.event?.eventoPozoId) {
        setFieldValue('ubication.event', val);
        if (val) {
          getEventsIdTeam(val);
          setEventState(val);
        }
      }
    },
    value: values.ubication.event
  };

  const objectTeam = {
    label: 'Equipo',
    placeholder: 'Selecciona un equipo',
    options: equipment,
    name: 'ubication.team',
    isDisabled: !values.ubication.ubicationType || !values.ubication.event,
    onChange: async (val) => {
      if (val?.id !== values?.team?.id) {
        setFieldValue('ubication.team', val);
        setTeamState(val);
      }
    },
    value: values.ubication.team
  };

  const objectInstallation = {
    label: 'Instalación',
    name: 'ubication.installation',
    onChange: (value) => {
      if (value !== values.ubication.installation?.id) {
        setFieldValue('ubication.installation', value);
        setFieldTouched('ubication.installation');
        if (value) {
          getOperationByInstallationId(value.id);
        }
      }
    },
    placeholder: 'Seleccione una instalación',
    value: values.ubication.installation,
    fetchData: (value) => fetchDataInstallation(value),
    isDisabled: disableUbicationSearch
  };

  const objectEquipment = {
    label: 'Equipo',
    name: 'ubication.equipment',
    onChange: (event) => {
      setFieldValue('ubication.equipment', event.target.value);
    },
    value: values.ubication.equipment,
    errors: 'Máximo 10 caracteres'
  };

  const objectClassification = {
    label: 'Clasificación',
    name: 'ubication.classification',
    onChange: (value) => {
      if (value.id !== values.ubication.classification?.id) {
        setFieldValue('ubication.classification', value);
        setFieldTouched('ubication.classification');
        if (value) {
          getOperationByClassificationId(value.id);
        }
      }
    },
    placeholder: 'Buscar por clasificación',
    value: values.ubication.classification,
    fetchData: (value) => fetchDataClassification(value),
    isDisabled: disableUbicationSearch
  };

  const objectTypeEvent = {
    label: 'Tipo de Evento',
    placeholder: 'Selecciona tipo de evento',
    options: typeOfEventOptions,
    name: 'ubication.typeEvent',
    isDisabled: !values.ubication?.ubication,

    onChange: (val) => {
      if (val?.id !== values?.ubication?.typeEvent?.id) {
        setFieldValue('ubication.typeEvent', val);
        setFieldTouched('ubication.typeEvent');
      }
    },
    isInvalid:
      errors?.ubication?.typeEvent && touched?.ubication?.typeEvent
        ? !!touched?.ubication?.typeEvent && !!errors?.ubication?.typeEvent
        : false,

    value: values.ubication?.typeEvent,
    errors: errors?.ubication?.typeEvent
  };

  useEffect(() => {
    setMaxWells(cantWells);
  }, [cantWells, setMaxWells]);

  useEffect(() => {
    setOptionUnits(isOyM ? filteredOperations : filteredBusinessUnits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOyM]);

  return (
    <div>
      <AddUbicationForm
        aditionalTeams={aditionalTeams}
        handleSwitchAdditionTeams={handleSwitchAdditionTeams}
        isMSDS
        objectClassification={objectClassification}
        objectEquipment={objectEquipment}
        objectEvent={objectEvent}
        objectInstallation={objectInstallation}
        objectTeam={objectTeam}
        objectTypeEvent={objectTypeEvent}
        objectUbication={objectUbication}
        objectUbicationType={objectUbicationType}
        objectUunn={objectUunn}
      />
    </div>
  );
};

LocationForm.propTypes = {
  params: PropTypes.shape({
    optionsUbicationType: PropTypes.arrayOf(PropTypes.shape),
    optionsBusinessOptions: PropTypes.arrayOf(PropTypes.shape),
    optionsOperations: PropTypes.arrayOf(PropTypes.shape),
    filteredOperations: PropTypes.arrayOf(PropTypes.shape),
    filteredBusinessUnits: PropTypes.arrayOf(PropTypes.shape),
    disabledChangeUunn: PropTypes.bool
  }),
  setMaxWells: PropTypes.func,
  isTemplate: PropTypes.bool.isRequired,
  createSDS: PropTypes.bool
};

LocationForm.defaultProps = {
  params: {
    optionsUbicationType: [],
    optionsBusinessOptions: [],
    optionsOperations: [],
    filteredBusinessUnits: [],
    filteredOperations: [],
    disabledChangeUunn: false
  },
  setMaxWells: () => {},
  createSDS: false
};
export default LocationForm;
